export enum ProductTypeEnum {
  /** Lisans Yok */
  None = 0,

  /** Enerji Doktoru */
  EnergyDoctor = 1,

  /** Enerji Doktoru (ücretsiz) */
  EnergyDoctorFree = 2,

  /** Kompanzasyon Doktoru */
  PowerFactorDoctor = 3,

  /** Kompanzasyon Doktoru (ücretsiz) */
  PowerFactorDoctorFree = 4,

  Sentinel = 5,
  EntBusPro = 6,
  EntBusPlus = 7,
  EntbusMobile = 8,

  // enermedic
  Enermedic = 99
}
